import { useState, useEffect } from "react";

const navLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Certificados", href: "#certificados" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Vantagens", href: "#diferenciais" },
  { label: "Dúvidas", href: "#faq" },
  { label: "Emitir agora", href: "#emitir" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-xl border-b border-background-200/70 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="#inicio" className="flex items-center gap-2 group">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-shield-check-line text-lg"></i>
          </span>
          <span className="font-heading text-primary-500 text-xl tracking-tight">
            AV<span className="italic text-accent-500">certifica</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="relative text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-accent-500 rounded-full transition-all group-hover:w-full" />
            </a>
          ))}
        </nav>

        <a
          href="https://wa.me/5547991891311"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          <i className="ri-whatsapp-line"></i>
          Falar no WhatsApp
        </a>

        <button
          className="lg:hidden text-primary-500 p-2"
          aria-label="Abrir menu"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50/95 backdrop-blur-xl border-b border-background-200/70 px-4 pb-4">
          <nav className="flex flex-col gap-3 pt-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-foreground-700 hover:text-primary-500 transition-colors py-2"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://wa.me/5547991891311"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 mt-2"
            >
              <i className="ri-whatsapp-line"></i>
              Falar no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}